<mat-icon [ngClass]="{'favorite': favorite}" (click)="toggleFavorite($event)">
  {{ favorite ? 'star' : 'star_border' }}
</mat-icon>

